import Vue from 'vue'
import Router from 'vue-router'
import EquipmentList from '@/pages/EquipmentList/EquipmentList.vue'
import StepOne from '@/pages/StepOne/StepOne.vue'
import StepTwo from '@/pages/StepTwo/StepTwo.vue'
import ScanFail from '@/pages/ScanFail/ScanFail.vue'
import ScanFail2 from '@/pages/ScanFail2/ScanFail2.vue'
import Canlendar from '@/pages/Canlendar/Canlendar.vue'
import CitySelect from '@/pages/CitySelect/CitySelect.vue'
import CutStyle from '@/pages/CutStyle/CutStyle.vue'
import DrinkWater from '@/pages/DrinkWater/DrinkWater.vue'
import Login from '@/pages/Login/Login.vue'
import Setting from '@/pages/Setting/Setting.vue'
import TakePills from '@/pages/TakePills/TakePills.vue'
import TakePillsSetting from '@/pages/TakePillsSetting/TakePillsSetting.vue'
import TomatoWork from '@/pages/TomatoWork/TomatoWork.vue'
import VersonUpdate from '@/pages/VersonUpdate/VersonUpdate.vue'
import Main from '@/pages/Main/Main.vue'
import ScanSuccess from '@/pages/ScanSuccess/ScanSuccess.vue'
import ChanelPreview from '@/pages/ChanelPreview/ChanelPreview.vue'
import Question from '@/pages/Question/Question.vue'
import UpdateDetail from '@/pages/UpdateDetail/UpdateDetail.vue'
import ChannelDetail from '@/pages/ChannelDetail/ChannelDetail.vue'
import About from '@/pages/About/About.vue'
import AboutEquipment from '@/pages/AboutEquipment/AboutEquipment.vue'
import hotSetting from '@/pages/hotSetting/hotSetting.vue'
import wifiSuccess from '@/pages/wifiSuccess/wifiSuccess.vue'
import MoreSetting from '@/pages/MoreSetting/MoreSetting.vue'
import BuyList from '@/pages/BuyList/BuyList.vue'
import BuyChannelDetail from '@/pages/BuyChannelDetail/BuyChannelDetail.vue'
import Agreement from '@/pages/Agreement/Agreement.vue'
import ConfigWiFi from '@/pages/ConfigWiFi/ConfigWiFi.vue'
import ConfigWiFi63 from '@/pages/ConfigWiFi63/ConfigWiFi.vue'
import ConfigWiFi120 from '@/pages/ConfigWiFi/ConfigWiFi120.vue'
import ModifyCalendarname from '@/pages/ModifyCalendarname/ModifyCalendarname.vue'
import ReminderList from '@/pages/Reminder/ReminderList.vue'
import ReminderDetail from '@/pages/ReminderDetail/ReminderDetail.vue'
import UpgradeVersionInstructions from '@/pages/UpgradeVersionInstructions/UpgradeVersionInstructions.vue'
import UpgradeVersionInstructions2 from '@/pages/UpgradeVersionInstructions2/UpgradeVersionInstructions2.vue'
import UpgradeVersionInstructions3 from '@/pages/UpgradeVersionInstructions/UpgradeVersionInstructions3.vue'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      meta: {keepAlive: true},
      beforeEnter: (to, from, next) => {
        window.history.pushState(null, null, '#/')
        // this.replace(to.path)
        next()
      }
    },
    {
      path: '/StepOne',
      name: 'StepOne',
      component: StepOne
    },
    {
      path: '/EquipmentList',
      name: 'EquipmentList',
      component: EquipmentList
    },
    {
      path: '/StepTwo',
      name: 'StepTwo',
      component: StepTwo
    },
    {
      path: '/Canlendar',
      name: 'Canlendar',
      component: Canlendar
    },
    {
      path: '/CitySelect',
      name: 'CitySelect',
      component: CitySelect
    },
    {
      path: '/CutStyle',
      name: 'CutStyle',
      component: CutStyle,
      beforeEnter: (to, from, next) => {
        if (from.name === 'Main') {
          localStorage.setItem('max_channel_from', 'Main')
        } else {
          localStorage.setItem('max_channel_from', 'detail')
        }
        next()
      },
      meta: {keepAlive: true}
    },
    {
      path: '/DrinkWater',
      name: 'DrinkWater',
      component: DrinkWater
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Setting',
      name: 'Setting',
      component: Setting,
      meta: {keepAlive: true}
    },
    {
      path: '/TakePills',
      name: 'TakePills',
      component: TakePills,
      beforeEnter: (to, from, next) => {
        if (from.name === 'TakePillsSetting') {
          localStorage.setItem('from', 'pullSetting')
        } else {
          localStorage.setItem('from', 'setting')
        }
        next()
      },
      meta: {keepAlive: true}
    },
    {
      path: '/TakePillsSetting',
      name: 'TakePillsSetting',
      component: TakePillsSetting
    },
    {
      path: '/TomatoWork',
      name: 'TomatoWork',
      component: TomatoWork
    },
    {
      path: '/VersonUpdate',
      name: 'VersonUpdate',
      component: VersonUpdate
    },
    {
      path: '/ScanSuccess',
      name: 'ScanSuccess',
      component: ScanSuccess
    },
    {
      path: '/wifiSuccess',
      name: 'wifiSuccess',
      component: wifiSuccess
    },
    {
      path: '/ScanFail',
      name: 'ScanFail',
      component: ScanFail
    },
    {
      path: '/ScanFail2',
      name: 'ScanFail2',
      component: ScanFail2
    },
    {
      path: '/ChanelPreview',
      name: 'ChanelPreview',
      component: ChanelPreview
    },
    {
      path: '/Question',
      name: 'Question',
      component: Question
    },
    {
      path: '/UpdateDetail',
      name: 'UpdateDetail',
      component: UpdateDetail
    },
    {
      path: '/ChannelDetail',
      name: 'ChannelDetail',
      component: ChannelDetail
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/AboutEquipment',
      name: 'AboutEquipment',
      component: AboutEquipment
    },
    {
      path: '/hotSetting',
      name: 'hotSetting',
      component: hotSetting
    },
    {
      path: '/MoreSetting',
      name: 'MoreSetting',
      component: MoreSetting
    },
    {
      path: '/BuyList',
      name: 'BuyList',
      component: BuyList
    },
    {
      path: '/BuyChannelDetail',
      name: 'BuyChannelDetail',
      component: BuyChannelDetail
    },
    {
      path: '/Agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/ConfigWiFi',
      name: 'ConfigWiFi',
      component: ConfigWiFi
    },
    {
      path: '/ConfigWiFi63',
      name: 'ConfigWiFi63',
      component: ConfigWiFi63
    },
    {
      path: '/ConfigWiFi120',
      name: 'ConfigWiFi120',
      component: ConfigWiFi120
    },
    {
      path: '/ModifyCalendarname',
      name: 'ModifyCalendarname',
      component: ModifyCalendarname
    },
    {
      path: '/ReminderList',
      name: 'ReminderList',
      component: ReminderList
    },
    {
      path: '/UpgradeVersionInstructions',
      name: 'UpgradeVersionInstructions',
      component: UpgradeVersionInstructions
    },
    {
      path: '/UpgradeVersionInstructions2',
      name: 'UpgradeVersionInstructions2',
      component: UpgradeVersionInstructions2
    },
    {
      path: '/UpgradeVersionInstructions3',
      name: 'UpgradeVersionInstructions3',
      component: UpgradeVersionInstructions3
    },
    {
      path: '/ReminderDetail',
      name: 'ReminderDetail',
      component: ReminderDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js